import { render, staticRenderFns } from "./ClaimAttachments.vue?vue&type=template&id=30840387&scoped=true&"
import script from "./ClaimAttachments.vue?vue&type=script&lang=js&"
export * from "./ClaimAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30840387",
  null
  
)

export default component.exports